module.exports = __webpack_public_path__ + "static/img/platformImg.661df6b9.png";